<template lang="pug">
div
  .h5.text-primary.mt-2 {{ $i18n.tModel("assunto.encerramento") }}
  situacoes(v-model="value.situacoes")
  integracao(v-model="value.integracao")
</template>

<script>
import Situacoes from "./Situacoes"
import Integracao from "./Integracao"

export default {
  components: { Situacoes, Integracao },
  props: { value: { type: Object, required: true } },
}
</script>
